<template>
    <div class="power">
        <Title firstName="发电统计" lastName="ELECTRICITY GENERATION STATISTICS"/>
        <div class="echarts">
            <div class="edata">
                <div class="edataCon">
                    <p>本月发电总量</p>
                    <p>{{total}}<span> kWh</span></p>
                </div>
                <!-- <div class="sevenDay" >近七日发电</div> -->
            </div>
            <div class="eview">
                <Bar :chartId="chartId" :seriesData="seriesData" :xData="xData" v-if="xData.length > 0"/>
            </div>
            <div class="bottom"></div>
        </div>
    </div>
</template>

<script>
const Title = () => import('../../../../components/title/Title')
const Bar = () => import('../../../../components/echarts/bar.vue')
import { getMonthTime, getSevenDays } from '../../../../utils/common/index'

export default {
    data(){
        return {
            chartId:'generationwei',
            xData:[],
            seriesData:[828, 812, 831, 840, 813, 830, 60]
        }
    },
    components:{
        Title,Bar
    },
    computed:{
        total(){
            let sum = 0
            this.seriesData.forEach(item =>{
                sum += item
            })
            return sum 
        }
    },
    mounted(){
        this.getWeekElectricity()
    },
    methods:{
        async getWeekElectricity(){
            let sevenDays = getSevenDays()
            console.log(sevenDays);

            let keys = Object.values(sevenDays)
            // console.log(keys);

            let days = []
            for(let i = 0;i <keys.length;i++){
                days.unshift(keys[i].substr(5))
            }

            this.xData = days
        }
    }
}
</script>

<style lang="less" scoped>
    .power{
        height: 33.3vh;
        width: 20vw;
        position: fixed;
        top: 64.4vh;
        left: 2vw;
        z-index: 1;

        .echarts{
            position: relative;
            height: 28.7vh;
            padding-bottom: 1vh;
            background:  linear-gradient(0deg, rgba(0, 33, 59, 0.6) 0%, rgba(3, 13, 24, 0.7) 100%);

            .edata{
                height: 9vh;
                display: flex;
                justify-content: space-around;
                padding: 3vh 0;
                .edataCon{
                    text-align: center;
                    p:nth-child(1){
                        font-size: 14rem;
                        font-family: Source Han Sans CN;
                        font-weight: 400;
                        color: rgba(230,243,253, 0.7);
                    }
                    p:nth-child(2){
                        padding-top: 3rem;
                        font-size: 20rem;
                        font-family: zcoolqingkehuangyouti;
                        font-weight: 400;
                        color: #00DEFF;
                        span{
                            font-size: 14rem;
                        }
                    }

                    
                }

                .sevenDay{
                    font-size: 12rem;
                    font-family: Microsoft YaHei;
                    font-weight: 400;
                    color: rgba(230,243,253, 0.7);
                    position: absolute;
                    right: 1vw;
                    top: 6.5vh;
                }
            }

            .eview{
                padding: 0 0.5vw;
                height: 17.9vh;
            }

            .bottom{
                width: 20vw;
                height: 1vh;
                background: url(../../../../assets/img/板块装饰线.png) no-repeat;
                block-size: 100% 100%;
                position: absolute;
                bottom: 0;
                left: 0;
            }
        }

        
    }

</style>